import React, { useEffect, useState } from "react";
import { Edit2, Trash2, Save, X, Plus } from "lucide-react";
import { baseURL } from "../network/baseUrl";
import { deleteProtected, getProtected, putProtected } from "../network/ApiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const ContractHistoryView = ({t , id =''  , refreshContracts=false  , isEditable = true  }) => {
   // Replace with your actual base URL


   const navigate = useNavigate() ; 
   
   
  
  const initialData = [
    {
      contract_start: "2024-11-01",
      status: "active",
      contract_price_euro: "750.50",
      contract_number: "9aa0c1e3-0a8a-4b52-b5d0-d1deb8678c6f",
      contract_end: "2027-10-31",
      contract_type: "leasing",
      created_at: "2025-06-26T16:18:59.326787Z",
      updated_at: "2025-06-26T16:18:59.326799Z",
      customer: {
        name: "Global Logistics Inc.",
        email: "procurement@globallogistics.com",
        phone_number: "+49 30 12345678",
        address: "Logistik-Allee 1, 10115 Berlin, Germany",
        customer_manager: 1,
        customer_company: "Global Logistics Inc.",
        customer_number: "001"
      },
      invoice_address_street: "Logistik-Allee 1",
      invoice_address_zip: "10115",
      invoice_address_city: "Berlin",
      invoice_address_country: "Germany",
    },
    {
      contract_start: "2025-01-01",
      status: "completed",
      contract_price_euro: "5000.00",
      contract_number: "3eba6068-5ca5-41b5-9997-a996e540c027",
      contract_end: "2025-12-31",
      contract_type: "sale",
      created_at: "2025-06-27T06:20:38.055197Z",
      updated_at: "2025-06-27T08:07:10.653388Z",
      customer: null,
      invoice_address_street: null,
      invoice_address_zip: null,
      invoice_address_city: null,
      invoice_address_country: null,
    },
  ];

  const [contracts, setContracts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);



  const getContractHistory = async () => {
      
    if(!id) return ; 
    try {
      const url = `${baseURL}/contract-asset/history/${id}`
      if (!url) {
        throw new Error("API endpoint not defined");
      }
      const response = await getProtected(url);
      console.log("response = ", response);
      if(Array.isArray(response) && response?.length > 0 ) 
      {
        setContracts(response) ; 
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error(t("dashboardToasters.sessionExpiration"));
        navigate("/login");
        return;
      }
     toast.error(t("dashboardToasters.genricError"));
    }
  };


  useEffect(() => {
    getContractHistory() ; 
  } , [refreshContracts] ) ; 

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  

  const getTypeBadge = (type) => {
    const typeColors = {
      leasing: "bg-purple-100 text-purple-800",
      sale: "bg-orange-100 text-orange-800",
      rental: "bg-teal-100 text-teal-800",
      demo: "bg-cyan-100 text-cyan-800",
      maintenance : "bg-orange-100 text-orange-800"
    };

    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-medium ${
          typeColors[type] || "bg-gray-100 text-gray-800"
        }`}
      >
        {type?.charAt(0).toUpperCase() + type?.slice(1) || "Unknown"}
      </span>
    );
  };

 
  


  

  return (
    <div className="p-6  bg-gray-50 max-h-400px">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-md font-medium mb-3 text-gray-700">
          {t("assetPageHeadings.contractHistory")}
          </h1>
        </div>

  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                   {t("contractHistoryModal.type")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("contractHistoryModal.start")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("contractHistoryModal.end")}
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t("contractHistoryModal.company")}
                  </th>
                 
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {contracts.map((contract) => (
                  <tr
                    key={contract?.contract_number}
                    className="hover:bg-gray-50"
                  >
                 

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="space-y-2">
                        {getTypeBadge(contract?.contract_type)}
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div>
                        <div className="text-sm text-gray-900">
                          
                          {formatDate(contract?.contract_start)}
                        </div>
                        
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div>
                      <div className="text-sm text-gray-900">
                          
                          {formatDate(contract?.contract_end)}
                        </div>
                      </div>
                    </td>

                   

                   
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <div>
                        {contract?.customer ? (
                          <>
                            <div className="text-sm text-gray-500">
                              {contract?.customer.customer_company ? contract?.customer.customer_company  : "N/A"}
                            </div>
                          </>
                        ) : (
                          <span className="text-sm text-gray-400">
                            {t("contractHistoryModal.noCustomerData")}
                          </span>
                        )}
                      </div>
                    </td>

                 
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-4 flex justify-between items-center">
          <div className="text-sm text-gray-500">
          {t("contractHistoryModal.showing")} {contracts?.length} {t("contractHistoryModal.contract")}
            {contracts.length !== 1 ? "s" : ""}
          </div>
          {/* <div className="text-sm text-gray-500">
            Last updated: {new Date().toLocaleString()}
          </div> */}
        </div>
      </div>

      
    </div>
  );
};

export default ContractHistoryView;